import { useSelector } from 'react-redux';
import { SINGLE_KPI_SCENARIO, VISUALISATION_OPTIONS } from '../constants';
import { mainContentInformation } from '../store/pathways/mainContentSlice';
import { mapDataHelper, Utils } from '../utils';

export default function useGraphInformation(mapOne, mapTwo, isLocked, minMax) {
  const { visualisation: selectedVisualisation } = useSelector(({ globalDomain }) => globalDomain.filters.global);
  const visualisation = VISUALISATION_OPTIONS.find((v) => v.index === selectedVisualisation);
  const comparedGraph = Object.keys(useSelector(({ globalDomain }) => globalDomain.filters.locked)).length !== 0;
  const customLegend = visualisation.value === SINGLE_KPI_SCENARIO;
  const legend = !(visualisation.value === SINGLE_KPI_SCENARIO || comparedGraph);

  const callInfos = useSelector(mainContentInformation);

  let mapOneOptions = mapOne ? mapDataHelper.getOptions(mapOne, callInfos, customLegend, isLocked, legend, 0, minMax?.mapOne) : {};
  const mapTwoOptions = mapTwo ? mapDataHelper.getOptions(mapTwo, callInfos, customLegend, isLocked, legend, 1, minMax?.mapTwo) : {};

  if (visualisation === SINGLE_KPI_SCENARIO) mapOneOptions = Utils.serieSorted(mapOneOptions);

  return { mapOneOptions, mapTwoOptions };
}
